module.exports = __webpack_public_path__ + "static/media/close_icon.77e2d203.svg";